export const parseFullSemanticalVersionFromInformationalVersion = (informationalVersion: string | undefined): string | undefined => {
  if (!informationalVersion) {
    return informationalVersion;
  }

  const matchResult = informationalVersion.match(/(.*\+(\d*\.)?)Branch/);
  if (!matchResult || matchResult.length <= 2) {
    return informationalVersion;
  }

  // last character is either '.' or '+' and should be removed
  const fullSemVerPart = matchResult[1];
  return fullSemVerPart.slice(0, -1);
};
